import i18next from 'i18next'

import { IS_APP_VISIBLE_STORAGE_KEY } from '@/constants/common'
import {
  isValidOrderId,
  openInProgressOrderNotificationPage,
  openNewOrderNotificationPage,
  setPendingNotificationOrderId
} from '@/utils/order-navigation.utils'

export { isValidOrderId } from '@/utils/order-navigation.utils'

export const createNewOrderBrowserNotification = (orderId: string) => {
  if (!isValidOrderId(orderId)) return

  const t = i18next.t

  const isAnyTabActive =
    localStorage.getItem(IS_APP_VISIBLE_STORAGE_KEY) === 'true'

  if (isAnyTabActive) return

  Notification?.requestPermission()?.then(() => {
    const notification = new Notification(t('orders.new-order.notification'), {
      icon: '/images/yassir-192.png',
      // image: '/images/yassir-192.png',
      tag: orderId
    })
    notification.onclick = () => {
      if (setPendingNotificationOrderId(orderId)) {
        openNewOrderNotificationPage()
      }
    }
  })
}

export const createAutoAcceptBrowserNotification = (orderId: string) => {
  if (!isValidOrderId(orderId)) return

  const t = i18next.t

  const isAnyTabActive =
    localStorage.getItem(IS_APP_VISIBLE_STORAGE_KEY) === 'true'

  if (isAnyTabActive) return

  Notification?.requestPermission()?.then(() => {
    const notification = new Notification(
      t('orders.auto-accept-order.notification'),
      {
        icon: '/images/yassir-192.png',
        tag: `auto-accept-${orderId}`
      }
    )
    notification.onclick = () => {
      if (setPendingNotificationOrderId(orderId)) {
        openInProgressOrderNotificationPage()
      }
    }
  })
}

export const createNotificationSound = (volume?: number) => {
  const audio = new Audio('/audio/new-order-notification-sound.mp3')
  audio.loop = true
  audio.volume = volume || 0.2
  return audio
}

export const createAutoAcceptChimeSound = (volume?: number) => {
  const audio = new Audio('/audio/auto-accept-chime.mp3')
  audio.loop = false
  audio.volume = volume || 0.2
  return audio
}

interface IChimeAudioElement extends HTMLAudioElement {
  _onChimeEnded?: () => void
  _chimeSessionActive?: boolean
  _lastChimeOrderId?: string
}

const stopChimePlayback = (audio: IChimeAudioElement) => {
  if (audio._onChimeEnded) {
    audio.removeEventListener('ended', audio._onChimeEnded)
    delete audio._onChimeEnded
  }
  audio.pause()
  audio.currentTime = 0
}

export const playAutoAcceptChime = (
  audio: IChimeAudioElement,
  chimeCount = 3,
  orderId?: string
) => {
  if (audio._chimeSessionActive) {
    return
  }

  if (orderId && audio._lastChimeOrderId === orderId) {
    return
  }

  audio._chimeSessionActive = true
  if (orderId) {
    audio._lastChimeOrderId = orderId
  }

  stopChimePlayback(audio)

  let chimePlayCount = 0
  const onChimeEnded = () => {
    chimePlayCount += 1
    if (chimePlayCount < chimeCount) {
      audio.currentTime = 0
      void audio.play()
    } else {
      stopChimePlayback(audio)
      delete audio._chimeSessionActive
    }
  }

  audio._onChimeEnded = onChimeEnded
  audio.addEventListener('ended', onChimeEnded)
  void audio.play()
}

export const stopAutoAcceptChime = (audio: IChimeAudioElement) => {
  stopChimePlayback(audio)
  delete audio._chimeSessionActive
}
